import React from 'react'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { formatAddress } from 'helpers/format'
import { Data } from 'Store/orders/types'
import InfoItem from './InfoItem'
import { Col, Row } from 'antd'
import LinkText from 'Components/text/LinkText'
import MapDrawer from './MapDrawer'
import { useState } from 'react'
import EditAddressDrawer from './EditAddressDrawer'
import { trim } from 'lodash'

type Props = {
  detail?: Data
  status?: string
  onSuccess?: () => void
}

const ReciverInfo: React.FunctionComponent<Props> = props => {
  const { detail, status = '', onSuccess = () => {} } = props

  const [showMap, setShowMap] = useState(false)
  const [isEditMap, setEditMap] = useState(false)

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const ReciverInfoMap = <MapDrawer isShow={showMap} onClose={() => setShowMap(false)} detail={detail} />
  const EditMapContent = (
    <EditAddressDrawer
      isShow={isEditMap}
      onClose={() => setEditMap(false)}
      onSuccess={() => {
        setEditMap(false)
        onSuccess()
      }}
      data={detail}
    />
  )
  const isPos = detail?.channel === 'pos'
  const addressEditable = isPos
  //&& status === 'success'
  return (
    <BoxWrapper>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row justify="space-between">
            <Col>
              <BoxTitle>ข้อมูลจัดส่ง</BoxTitle>
            </Col>
            <Col>
              {addressEditable ? (
                <Link color={Theme.colors.primary} onClick={() => setEditMap(true)}>
                  แก้ไขที่อยู่จัดส่ง
                </Link>
              ) : (
                <Link color={Theme.colors.primary} onClick={() => setShowMap(true)}>
                  ดูแผนที่
                </Link>
              )}
            </Col>
          </Row>

          {renderInfo('ชื่อ', detail?.shipping_address?.receiver_name || '-')}
          {renderInfo(
            'หมายเลขโทรศัพท์',
            trim(detail?.shipping_address?.tel !== '' ? detail?.shipping_address?.tel : '-'),
          )}
          {renderInfo(
            'ที่อยู่จัดส่ง',
            formatAddress(
              detail?.shipping_address?.address,
              detail?.shipping_address?.sub_district,
              detail?.shipping_address?.district,
              detail?.shipping_address?.province,
              detail?.shipping_address?.zipcode,
            ),
          )}
          {/* {renderInfo('จุดสังเกตุ', '*')} */}
        </Col>
      </Row>
      {ReciverInfoMap}
      {EditMapContent}
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Link = styled(LinkText)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

export default ReciverInfo
